import { Alert, Button, Card, Form, Input, InputNumber } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import adSizeApi from './AdSizeApi'

const FormItem = Form.Item

interface Props {

}

const AdSizeEdit: React.FC<Props> = () => {

    const [form] = useForm()
    const [error, setError] = useState()
    const navigateTo = useNavigate()

    const { id } = useParams<{ id: string }>()

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await adSizeApi.edit(id, values)
            navigateTo('/ad-size')
        } catch (e) {
            setError(e.error)
        }
    }

    const loadData = async () => {
        try {
            const response = await adSizeApi.view(id)
            form.setFieldsValue(response.data)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
    >
        {error ? <Alert message={error} type="error" /> : null}
        <Card title="Ad Size" size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
            >
                <Input placeholder="Name"/>
            </FormItem>
            <FormItem
                required
                name="width"
                label="Width"
            >
                <InputNumber placeholder="Width" min={1} max={10000} />
            </FormItem>
            <FormItem
                required
                name="height"
                label="Height"
            >
                <InputNumber placeholder="Height" min={1} max={10000} />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Save</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/ad-size')}>Cancel</Button>
        </div>
    </Form>
}

export default AdSizeEdit


// WEBPACK FOOTER //
// ./src/component/app/adSize/AdSizeEdit.tsx